import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const WhatsAppButton = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    setIsVisible(true);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const whatsappNumber = '5216243001035';

  const message =
    language === 'en'
      ? encodeURIComponent('Hi! I would like to get a quote for a project from GR8.')
      : encodeURIComponent('¡Hola! Me gustaría obtener una cotización para un proyecto de GR8.');

  const handleClick = () => {

    // META PIXEL LEAD
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: 'WhatsApp Click',
        content_category: 'Contact',
        source: 'Floating WhatsApp Button'
      });
    }

    // GOOGLE ADS CONVERSION (ID CORREGIDO)
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-8482711845/rsJSCNCSsfkbEPjKuPFC'
      });
    }

    window.open(
      `https://wa.me/${whatsappNumber}?text=${message}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-50 animate-fade-in-up">
          <div className="relative">

            {isExpanded && (
              <div className="absolute bottom-20 right-0 bg-white text-slate-900 px-4 py-3 rounded-lg shadow-xl whitespace-nowrap animate-fade-in-up">
                <p className="font-semibold mb-1">Chat with us!</p>
                <p className="text-sm text-slate-600">We're here to help</p>
                <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white"></div>
              </div>
            )}

            <button
              onClick={handleClick}
              onMouseEnter={() => setIsExpanded(true)}
              onMouseLeave={() => setIsExpanded(false)}
              className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-200 animate-pulse-soft"
            >
              <MessageCircle className="h-8 w-8" />
            </button>

            <span className="absolute top-0 right-0 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
            </span>

          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
